import React from "react";
var __jsx = React.createElement;
import stl from "./PaymentTabBoxPopup.module.css";
import BottomSheetPopup from "@componentsShared/BottomSheetPopup__OLD/BottomSheetPopup";
import { useTranslation } from "@i18n";
var PaymentTabBoxPopup = function PaymentTabBoxPopup(_ref) {
  var _priceSection$finance, _priceSection$finance2, _priceSection$finance3, _priceSection$finance4;
  var onClose = _ref.onClose,
    priceSection = _ref.priceSection,
    isUsed = _ref.isUsed;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(BottomSheetPopup, {
    show: true,
    onClose: onClose,
    className: stl.customPopUp
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.kastDetails
  }, /*#__PURE__*/React.createElement("strong", null, t("تفاصيل التمويل", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("div", {
    className: stl.kastInfo2
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.kastRowHeading
  }, /*#__PURE__*/React.createElement("span", null, t("يبدأ القسط من", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance = priceSection.finance_price) === null || _priceSection$finance === void 0 ? void 0 : _priceSection$finance.text, /*#__PURE__*/React.createElement("span", null, t("ريال/شهرياً", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("مدة القسط", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance2 = priceSection.finance_price) === null || _priceSection$finance2 === void 0 ? void 0 : _priceSection$finance2.installment_period, /*#__PURE__*/React.createElement("span", null, t("شهر", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("الدفعة الأولى", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance3 = priceSection.finance_price) === null || _priceSection$finance3 === void 0 ? void 0 : _priceSection$finance3.first_payment, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t("ريال", {
    ns: "web_post_view"
  })))), /*#__PURE__*/React.createElement("div", {
    className: stl.kastRow
  }, /*#__PURE__*/React.createElement("span", null, t("الدفعة الأخيرة", {
    ns: "web_post_view"
  })), /*#__PURE__*/React.createElement("strong", null, priceSection === null || priceSection === void 0 ? void 0 : (_priceSection$finance4 = priceSection.finance_price) === null || _priceSection$finance4 === void 0 ? void 0 : _priceSection$finance4.last_payment, /*#__PURE__*/React.createElement("span", {
    className: "text-2xl"
  }, t("ريال", {
    ns: "web_post_view"
  }))))), /*#__PURE__*/React.createElement("p", {
    className: stl.NewKastNot
  }, isUsed ? t("هذا السعر تقديري ولا يتضمن التأمين الشامل للسيارة", {
    ns: "web_post_view"
  }) : t("هذا السعر تقديري ويتضمن التأمين الشامل للسيارة", {
    ns: "web_post_view"
  })))));
};
export default PaymentTabBoxPopup;